// Import Swiper core and required modules
import Swiper from 'swiper';
import { Navigation, FreeMode } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';

// ✅ Initialize always-active swiper
const swiper = new Swiper('.mySwiper', {
  modules: [Navigation, FreeMode],
  slidesPerView: 1,
  spaceBetween: 96,
  grabCursor: true,
  freeMode: true,
  freeModeMomentum: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    }
  }
});

// ✅ Conditionally init/destroy .newsSwiper
let newsSwiper = null;

function handleNewsSwiper() {
  const isMobile = window.innerWidth <= 1400;

  if (isMobile && !newsSwiper) {
    newsSwiper = new Swiper('.newsSwiper', {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 96,
      grabCursor: true,
      navigation: {
        nextEl: '.news-swiper-next',
        prevEl: '.news-swiper-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        }
      }
    });
  } else if (!isMobile && newsSwiper) {
    newsSwiper.destroy(true, true);
    newsSwiper = null;
  }
}

// ✅ Initial check
handleNewsSwiper();

// ✅ Watch for window resize
window.addEventListener('resize', handleNewsSwiper);
